import { render, staticRenderFns } from "./CasesList.vue?vue&type=template&id=1edf485a&scoped=true"
import script from "./CasesList.vue?vue&type=script&lang=js"
export * from "./CasesList.vue?vue&type=script&lang=js"
import style0 from "./CasesList.vue?vue&type=style&index=0&id=1edf485a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf485a",
  null
  
)

export default component.exports